import { render, staticRenderFns } from "./ListaAtividades.vue?vue&type=template&id=75cada1a"
import script from "./ListaAtividades.vue?vue&type=script&lang=js"
export * from "./ListaAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports